module.exports = __webpack_public_path__ + "static/media/adv.99a92911.svg";